import { getCurriculumKeyFromStateOrParams } from '@store/curriculum/curriculumAndAnnotationHelper';
import {
  selectCurriculumAttachments,
  selectFullAnnotatedCurriculumViewModel,
} from '@store/curriculum/curriculumSelectors';
import { createTypedSelector } from '@store/genericHelpers';
import type { CurriculumParams } from '../../../../types/selectorTypes';
import settings from '@config/settings';
import type { ApiStudyProgrammeGroup } from '../../../../types/samApiTypes';
import type { Attachment } from '../../../../types/contentApiTypes';

function getImageUrl(grade: ApiStudyProgrammeGroup | undefined, attachments: Attachment[]) {
  const gradeNumber = grade?.title || 4;
  const defaultImg = `/headers/headerbg${gradeNumber}.png`;

  const att = attachments?.find((att) => att.type === 'COVER_IMAGE');

  if (!att) {
    return defaultImg;
  }
  return settings.apisAndUrls.cachedApi.baseUrl + att.href;
}

export const selectCurriculumHeaderInfo = createTypedSelector(
  [
    // @ts-expect-error type inferrence not done
    (state, params?: CurriculumParams) => selectFullAnnotatedCurriculumViewModel(state, params),
    (state, params?: CurriculumParams) => selectCurriculumAttachments(state, params),
    (state, params?: CurriculumParams) =>
      getCurriculumKeyFromStateOrParams(state, params) === 'nonderived',
  ],
  (model, curriculumAttachments, isNonderived) => {
    if (!model) {
      return null;
    }

    return {
      backgroundImage: getImageUrl(model?.grade, curriculumAttachments),
      curriculumTitle: model.title,
      version: model.versionNumber,
      educationalPointers: model.educationalPointers,
      generalLevel: model.generalLevel,
      schoolLevel: model.schoolLevel,
      educationalComponents: model.educationalComponents,
      curriculumType: model.curriculumType,
      subtitle: model.subTitle,
      validityPeriod: model.validityPeriodString,
      studyProgram: model.studyProgram,
      isNonderived,
    };
  },
);
